/*
 * @Description: 性能监控分析配置， 只在生产环境 进行监控
 * @Author: luozhao
 * @Date: 2021-09-13 11:23:43
 */
// 生产环境 正式线添加 代码性能分析统计
if (process.env.VUE_APP_MODE == "prod") {
  try {
    // eslint-disable-next-line
     const aegis = new Aegis({
      id: 'DvRD5SElkZpwWDQKYe', // 上报 id 各应用唯一id，找前端负责人申请
      uin: 'whty-web-pt-khfw', // 用户唯一 ID（可选）移动端: whty-touch-部门首字母小写-应用首字母小写  web端: whty-web-部门首字母小写-应用首字母小写
      reportApiSpeed: {
        // 无restful 测速 reportApiSpeed = true
        // 页面中有 restful 风格的接口 配置handler
        // restful接口例子: www.example.com/user/1001
        urlHandler(url) {
          // 需要为每个restful接口单独配置,
          if (/www\.example\.com\/user\/\d*/.test(url)) {
            return 'www.example.com/user/:id';
          }
          return url;
        }
      }, // 接口测速
      // reportApiSpeed: true,
      reportAssetSpeed: true, // 静态资源测速
      spa: true, // spa 应用页面跳转的时候开启 pv 计算
      api: {
        apiDetail: true,
        retCodeHandler(data) {
          // data 是string类型，如果需要对象需要手动parse下
          // url 为请求url
          // xhr 响应,可以通过xhr.response拿到完整的后台响应
          try {
            data = (typeof data === 'string') ? JSON.parse(data) : data;
          } catch (e) {
            console.log(e);
          }
          // 返回根据 接口所使用的 code码来判断 需把业务中各种code都加在判断中
          const { code, retCode, result } = data;
          return {
            isErr: !(code === '000000' || result === '000000' || retCode === '000000'),
            code: code || result || retCode
          };
        }
      },
      beforeReportSpeed(log) {
        log.url = decodeURIComponent(log.url);
        log.url = log.url.replace(/[a-zA-z]+:\/\/[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/g, '');
        return log;
      },
      beforeReport(log) {
        var str1 = log.msg.replace(/[\r\n]/g, '-----');
        var arr = str1.split('-----');
        arr.forEach((item, index) => {
          if (item.indexOf('res data: {') >= 0) {
            // arr.splice(index, 1);
            arr[index] = `${item.substring(item.indexOf('{'), item.indexOf(','))}}`;
          }
        });
        log.msg = arr.join('\n').replace(/[a-zA-z]+:\/\/[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/g, '');
        if (log.level === '4' && log.msg && (log.msg.indexOf('ResizeObserver') !== -1 || log.msg.indexOf('Script error') !== -1)) {
          return false;
        } else {
          return log;
        }
      }
    });
  } catch (e) {
    console.log(e);
  }
}
